// extracted by mini-css-extract-plugin
export default {"container":"container___ycHJy","form":"form___ghQ0d","buttonBox":"buttonBox___zIBNs","priceBox":"priceBox___cVwyJ"};